import React from "react";
import {Form, Message, Modal, Table} from "semantic-ui-react";
import userStore from "../stores/userStore";
import Button from "semantic-ui-react/dist/commonjs/elements/Button";
import {observable} from "mobx";
import {observer} from "mobx-react";
import {checkEdit, checkRole} from "../helper/rolehelper";
import Icon from "semantic-ui-react/dist/commonjs/elements/Icon";
import DatePicker from "react-datepicker";
import NumberFormat from "react-number-format";

const DEFAULT_ERROR = "Werte dürfen nicht 0, oder leer sein.";
const TYPE_ERROR = "Falsche Angabe : Art der Tanklieferung";
const LOCATION_ERROR = "Falsche Angabe : Ort wurde nicht angegeben oder Wert ist falsch";

@observer
export default class AcetylenRow extends React.Component {

    @observable
    editAcetylen = {
        acetylenType: 1,
        date: new Date(),
        amountliter: 0,
        calorificvalue: 0,
        amountkWh: 0,
        costs: 0,
        proof: "",
        locationId: 0,
        id: 0,
        comment: ""
    };
    @observable
    error = false;

    @observable
    isEditModal = false;

    @observable
    addacetylenModalOpen = false;

    @observable
    deleteModalOpen = false;

    @observable
    errorMessage = DEFAULT_ERROR;

    @observable privilegedUser = false;

    @observable edit = false;

    componentDidMount() {
    }


    constructor(props) {
        super(props);

        let user = userStore.userRolesFromServer;
        if (checkRole(user, "/acetylen")) {
            this.privilegedUser = true;
        } else {
            this.privilegedUser = user.toString().includes("admin");
        }
        this.edit = checkEdit(user, "/acetylen");

        this.state = {
            open: false,
            deleteopen: false,
            delete: true,
            edit: true
        }
    }

    getAcetylenName(type) {
        if (type === 1) {
            return "Tanklieferung";
        } else if (type === 2) {
            return "Tankkartenabrechnungen";
        } else if (type === 3) {
            return "FremdTankungen";
        } else {
            //todo:error
        }
    }

    //functions for edit
    checkInputValues() {
        console.log(this.editAcetylen);
        //Check if vehicle has acetylen and check if amounts are right
        if (this.editAcetylen.length !== 0) {

            //Check if editHeatingoil has a valid type (1, 2 or 3)
            let type = (this.editAcetylen.acetylenType);
            if (type !== 1) {
                this.error = true;
                console.log(this.error);
                this.errorMessage = TYPE_ERROR;
                return;
            }

            //Check if location-Id has a valid type (not null, empty or undefined (valid = 1 - 7))
            let locationId = this.editAcetylen.locationId;
            console.log(locationId);
            if (locationId === null || locationId === '' || locationId === undefined) {
                this.error = true;
                this.errorMessage = LOCATION_ERROR;
                return;
            }

            let amountliter = this.editAcetylen.amountliter;
            let costs = this.editAcetylen.costs;
            let proof = this.editAcetylen.proof;
            if (amountliter === "" || costs === "" || amountliter === 0 || costs === "" || costs === 0 || proof === "") {
                this.error = true;
                this.errorMessage = DEFAULT_ERROR;
                console.log("value error");
                console.log(this.error);
                return;
            }
            this.setEdit();
        } else {
            this.error = true;
            console.log(this.error);
        }
    }

    setEdit() {
        console.log(this.editAcetylen.date);

        this.props.editAcetylen(this.editAcetylen, (this.editAcetylen.acetylenType));

        this.closeInput()
    }


    openEditAcetylenModal() {
        this.editAcetylen.acetylenType = this.props.acetylen.acetylenType;
        this.editAcetylen.date = new Date(this.props.acetylen.date * 1000);
        this.editAcetylen.amountliter = this.props.acetylen.amountliter;
        this.editAcetylen.calorificvalue = this.props.acetylen.calorificvalue;
        this.editAcetylen.amountkWh = this.props.acetylen.amountkWh;
        this.editAcetylen.costs = this.props.acetylen.costs;
        this.editAcetylen.proof = this.props.acetylen.proof;
        this.editAcetylen.comment = this.props.acetylen.comment;
        this.editAcetylen.locationId = this.props.locationId;
        this.editAcetylen.id = this.props.acetylen.id;
    }

    handleChange(date) {
        if (date === null) {
            this.setState({
                ...this.state,
                error: true
            })
        } else {
            this.editAcetylen.date = date;
        }
    }


    getTypeId(name) {
        if (name === "Tanklieferung") {
            return 1;
        } else if (name === "Tankkarte") {
            return 2;
        } else {
            return 3;
        }
    }

    closeInput() {

        this.isEditModal = false;
        this.addacetylenModalOpen = false;
        this.state.open = false;
        this.deleteModalOpen = false;
        this.editAcetylen = {
            acetylenType: this.props.acetylen.acetylenType,
            date: new Date(this.props.acetylen.date * 1000),
            amountliter: this.props.acetylen.amountliter,
            calorificvalue: this.props.acetylen.calorificvalue,
            amountkWh: this.props.acetylen.amountkWh,
            costs: this.props.acetylen.costs,
            proof: this.props.acetylen.proof,
            locationId: this.props.locationId,
            comment: this.props.acetylen.comment,
            id: this.props.acetylen.id
        };

        this.error = false;
    }


    handleInputChange(type, event, data) {
        this.editAcetylen.calorificvalue = 13.53;

        this.editAcetylen.amountkWh = this.editAcetylen.amountliter * this.editAcetylen.calorificvalue;
        if (type === 'acetylenType') {
            this.editAcetylen.acetylenType = data.value;
        } else if (type === 'date') {
            this.editAcetylen.date = data.value;
        } else if (type === 'costs') {
            if (data.value === "") {
                this.editAcetylen.costs = 0;
            } else
                this.editAcetylen.costs = data.value;
        } else if (type === 'amountliter') {
            if (data.value === "") {
                this.editAcetylen.amountliter = 0;
            } else {
                this.editAcetylen.amountliter = data.value;
            }
        } else if (type === 'proof') {
            this.editAcetylen.proof = data.value;
        } else if (type === 'comment') {
            this.editAcetylen.comment = data.value;
        }
        this.editAcetylen.locationId = this.props.locationId;
    }

    //functions for edit


    //functions for delete


    openDeleteAcetylenModal(acetylensId) {
        this.deleteModalOpen = true;
        console.log(this.props.acetylen)
        this.props.deleteAcetylen(acetylensId);
        this.closeDeleteInput();
    }


    closeDeleteInput() {
        this.addacetylenModalOpen = false;
        this.isEditModal = false;
        this.state.deleteopen = false;
        this.deleteModalOpen = false;
        this.editAcetylen = {
            acetylenType: 1,
            date: new Date(),
            amountliter: "",
            calorificvalue: "",
            amountkWh: "",
            costs: "",
            proof: "",
            comment: ""
        };
        console.log(this.state.deleteopen);
        this.error = false;
    }

    //functions for delete


    getTypeId(name) {
        if (name === "Tanklieferung") {
            return 1;
        } else if (name === "Tankkarte") {
            return 2;
        } else {
            return 3;
        }
    }

    render() {
        const IdOptions = [
            {key: 4, text: 'Tanklieferung', value: 1},
            {key: 5, text: 'Tankkarte', value: 2},
            {key: 6, text: 'Fremdtankung', value: 3}
        ];
        const calorificvalue = 13.53;

        return (

            <Table.Row className="color-sub-row">
                <Table.Cell/>
                {this.edit ?
                    <Table.Cell>
                        <Modal open={this.state.deleteopen} className={"modal-top"}
                               onClose={this.closeDeleteInput.bind(this)} centered={false}
                               trigger={this.delete ?
                                   <Icon name='delete' color="red"
                                         onClick={() => this.setState({deleteopen: true, delete: true})}/>
                                   :
                                   <Icon name='delete' color="red"
                                         onClick={() => this.setState({deleteopen: true, delete: true})}/>
                               }>
                            <Modal.Header>Löschen</Modal.Header>
                            <Modal.Content>
                                Sicher löschen?
                            </Modal.Content>
                            <Modal.Actions>
                                <Button negative icon='delete' onClick={this.closeDeleteInput.bind(this)}/>
                                <Button
                                    positive
                                    icon='checkmark'
                                    onClick={this.openDeleteAcetylenModal.bind(this, this.props.acetylen.id)}

                                />
                            </Modal.Actions>
                        </Modal>
                    </Table.Cell>
                    :
                    null
                }
                {this.edit ?
                    <Table.Cell>
                        <Modal centered={false} className={"modal-top"} open={this.state.open} size="small"
                               trigger={
                                   <Icon name='edit' color="green"
                                         onClick={() => {
                                             this.openEditAcetylenModal();
                                             this.setState({open: true, edit: true});
                                         }}/>
                               }>
                            <Modal.Header>{this.isEditModal ? "Bearbeiten" : "Hinzufügen"}</Modal.Header>
                            <Modal.Content>
                                <Form error={this.error}>
                                    <Form.Group widths='equal'>


                                        <Form.Field>
                                            <label>Datum</label>

                                            <DatePicker
                                                selected={this.editAcetylen.date}
                                                onChange={this.handleChange.bind(this)}
                                                dateFormat="dd.MM.yyyy"
                                            />
                                        </Form.Field>
                                    </Form.Group>
                                    <Form.Group widths='equal'>
                                        <Form.Field>
                                            <label>Menge [l]</label>
                                            <NumberFormat value={parseFloat(this.editAcetylen.amountliter)}
                                                          thousandSeparator="."
                                                          decimalSeparator=","
                                                          decimalScale={2}
                                                          onValueChange={(values, e) => {
                                                              this.handleInputChange('amountliter', null, {value: values.floatValue})
                                                          }}
                                                          allowNegative={false}
                                                          suffix=" l"/>
                                        </Form.Field>
                                        <Form.Field>
                                            <label>Heizwert</label>
                                            {calorificvalue}
                                        </Form.Field>
                                        <Form.Field>
                                            <label>kWh</label>
                                            {Math.round(this.editAcetylen.amountliter * calorificvalue * 100) / 100}
                                        </Form.Field>
                                        <Form.Field>
                                            <label>Kosten [€]</label>
                                            <NumberFormat value={parseFloat(this.editAcetylen.costs)}
                                                          thousandSeparator="."
                                                          decimalSeparator=","
                                                          decimalScale={2}
                                                          onValueChange={(values, e) => {
                                                              this.handleInputChange('costs', null, {value: values.floatValue})
                                                          }}
                                                          allowNegative={false}
                                                          suffix=" €"/>
                                        </Form.Field>
                                    </Form.Group>
                                    <Form.Group widths='equal'>
                                        <Form.Field>
                                            <label>Nachweis</label>
                                            <Form.Input value={this.editAcetylen.proof}
                                                        type='proof'
                                                        onChange={this.handleInputChange.bind(this, 'proof')}/>
                                        </Form.Field>
                                        <Form.Field>
                                            <label>Bemerkung</label>
                                            <Form.Input value={this.editAcetylen.comment}
                                                        type='comment'
                                                        onChange={this.handleInputChange.bind(this, 'comment')}/>
                                        </Form.Field>

                                    </Form.Group>
                                    <Message
                                        error
                                        header='Fehler'
                                        content={this.errorMessage}
                                    />
                                </Form>
                            </Modal.Content>
                            <Modal.Actions>
                                <Button negative icon='delete' onClick={this.closeInput.bind(this)}/>
                                <Button
                                    positive
                                    icon='checkmark'
                                    onClick={() => this.checkInputValues()}
                                />
                            </Modal.Actions>
                        </Modal>
                    </Table.Cell>
                    :
                    null
                }
                <Table.Cell>
                    {new Date(this.props.acetylen.date * 1000).toLocaleDateString()}
                </Table.Cell>
                <Table.Cell>
                    {new Intl.NumberFormat('de-DE', {style: 'decimal'}).format(this.props.acetylen.amountliter.toFixed(2))}
                </Table.Cell>
                <Table.Cell>
                    {new Intl.NumberFormat('de-DE', {style: 'decimal'}).format(this.props.acetylen.calorificvalue)}
                </Table.Cell>
                <Table.Cell>
                    {new Intl.NumberFormat('de-DE', {style: 'decimal'}).format(this.props.acetylen.amountkWh.toFixed(2))}
                </Table.Cell>
                <Table.Cell>
                    {new Intl.NumberFormat('de-DE', {
                        style: 'currency',
                        currency: 'EUR'
                    }).format(this.props.acetylen.costs.toFixed(2))}€
                </Table.Cell>
                <Table.Cell>
                    {this.props.acetylen.comment}
                </Table.Cell>
                <Table.Cell>
                    {this.props.acetylen.proof}
                </Table.Cell>
            </Table.Row>
        );
    }
}